<div class="subscription">
  <div class="wrapper">
    <div class="head">
      <div class="head-img" />
    </div>
    <div class="subscription_contents">
      <h3>클래스 정기결제 상품 이용 정보</h3>
      <div class="subscription_section">
        <h4>&bull; 고스톱 클래스</h4>
        <table class="tbl th_row">
          <colgroup>
            <col width="30%">
            <col width="">
          </colgroup>
          <tr>
            <th>이용상품</th>
            <td></span>{{subscription}}</td>
          </tr>
          <tr>
            <th>결제 금액</th>
            <td><span class="price">{{addComma lastPaidAmount}}원</span></td>
          </tr>
          <tr>
            <th>다음 결제 예정일</th>
            <td>{{nextPaymentDate}}</td>
          </tr>
          <tr>
            <th>연속 이용 개월 수</th>
            <td>{{continuousMonth}}</td>
          </tr>
        </table>
        <div class="unsubscribe" alt={{platformDetail}}>
          <!-- #1. 모바일 게임 접속 / 구글에서 결제 -->
          {{#if (equal platformDetail "mobile/google")}}
          <span class="info">해지는 구글스토어 구독관리에서 할 수 있습니다.</span>
          <a href="https://play.google.com/store/account/subscriptions" class="btn_square btn_apply"><span>정기결제
              해지하기</span></a>
          {{/if}}

          <!-- #2. PC 게임 접속 / PC에서 결제 -->
          {{#if (equal platformDetail "pc-game/pc")}}
          {{#if isCancelling }}
          <a href="#" data-subs-click="rollback" class="btn_square btn_cancel"><i class="icon"></i><span>클래스 해지 예약
              취소</span></a>
          {{else}}
          <a href="#" data-subs-click="changePayment" class="btn_square btn_change"><i class="icon"></i><span>결제수단
              변경</span></a>
          <a href="#" data-subs-click="unsubscribe" class="btn_square btn_unsubscribe"><i class="icon"></i><span>클래스 해지
              예약</span></a>
          {{/if}}
          {{/if}}

          <!-- #3. PC 게임 접속 / 구글에서 결제 -->
          {{#if (equal platformDetail "pc-game/google")}}
          <span class="info">해지는 구글스토어 구독관리에서 할 수 있습니다.</span>
          {{/if}}

          <!-- #4. 모바일 게임 접속 / PC에서 결제 -->
          {{#if (equal platformDetail "mobile/pc")}}
          <span class="info">PC게임에서 접속후 클래스 해지 예약을 할 수 있습니다.</span>
          {{/if}}
        </div>

        {{#if isUsingAccount}}
        <div class="section">
          <h4>&bull; 고스톱 출금통장(PC)</h4>
          <table class="tbl th_row">
            <colgroup>
              <col width="30%">
              <col width="">
            </colgroup>
            <tr>
              <th>이용상품</th>
              <td>{{accountText}}</td>
            </tr>
            <tr>
              <th>결제금액</th>
              <td><span class="price">{{accountPayAmount}}</span></td>
            </tr>
            <tr>
              <th>다음 결제 예정일</th>
              <td id="id_next_sub_pay_dt">{{accountNextPaymentDate}}</td>
            </tr>
            <tr>
              {{#if accountPayType}}
            <tr>
              <td>{{accountPayType}}</td>
            </tr>
            {{/if}}
          </table>
          <div class="unsubscribe" alt={{platformDetail}}>
            <!-- #1. 모바일 게임 접속 / 구글에서 결제 -->
            {{#if (equal platformDetail "mobile/google")}}
            <span class="info">해지는 구글스토어 구독관리에서 할 수 있습니다.</span>
            <a href="https://play.google.com/store/account/subscriptions" class="btn_square btn_apply"><i
                class="icon"></i><span>정기결제 해지하기</span></a>
            {{/if}}

            <!-- #2. PC 게임 접속 / PC에서 결제 -->
            {{#if (equal platformDetail "pc-game/pc")}}
            {{#if isCancelling }}
            <a href="#" data-subs-click="rollbackAccount" class="btn_square btn_cancel"><i class="icon"></i><span>출금통장
                해지 예약 취소</span></a>
            {{else}}
            <a href="#" data-subs-click="changePayment" class="btn_square btn_change"><i class="icon"></i><span>결제수단
                변경</span></a>
            <a href="#" data-subs-click="unsubscribeAccount" class="btn_square btn_unsubscribe"><i
                class="icon"></i><span>출금통장 해지 예약</span></a>
            {{/if}}
            {{/if}}

            <!-- #3. PC 게임 접속 / 구글에서 결제 -->
            {{#if (equal platformDetail "pc-game/google")}}
            <span class="info">해지는 구글스토어 구독관리에서 할 수 있습니다.</span>
            {{/if}}

            <!-- #4. 모바일 게임 접속 / PC에서 결제 -->
            {{#if (equal platformDetail "mobile/pc")}}
            <span class="info">PC게임에서 접속후 클래스 해지 예약을 할 수 있습니다.</span>
            {{/if}}
          </div>
          {{/if}}

          <h3>정기결제 내역</h3>
          <div class="section">
            <table class="tbl">
              <colgroup>
                <col width="">
                <col width="50%">
                <col width="">
              </colgroup>
              <tr>
                <th>결제일</th>
                <th>이용상품</th>
                <th>결제금액</th>
              </tr>
              {{#history}}
              <tr>
                <td><em>{{{paidDate}}}</em></td>
                <td>{{subscription}}</td>
                <td><span class="price">{{#if paidAmount}}{{addComma paidAmount}}원{{/if}}</span></td>
              </tr>
              {{/history}}
            </table>
          </div>

        </div>
      </div>
    </div>